import { Button } from "@mui/material";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IScheduleAppointment } from "../../../model";
import CancelSchedule from "./NewCancelSchedule";
import { ISelectType } from "../../../../../components/UI/Inputs/AutoCompleteText";

interface ICancelScheduleButton {
  tasySchedulingTypeCode: string;
  appointment: IScheduleAppointment;
  onCancelled: () => void;
  cancellationReasonOptions?: ISelectType[];
}

const NewCancelScheduleButton: React.FC<ICancelScheduleButton> = ({
  appointment,
  tasySchedulingTypeCode,
  onCancelled,
  cancellationReasonOptions,
}) => {
  const { t } = useTranslation();
  const [openCancelModal, setOpenCancelModal] = useState(false);

  return (
    <>
      {tasySchedulingTypeCode && appointment && (
        <CancelSchedule
          data={appointment}
          type={tasySchedulingTypeCode}
          onClose={() => setOpenCancelModal(false)}
          open={openCancelModal}
          onCancelled={onCancelled}
          cancellationReasonOptions={cancellationReasonOptions}
        />
      )}
      <Button
        startIcon={<CloseRoundedIcon />}
        onClick={() => setOpenCancelModal(true)}
        color="error"
        variant="outlined"
      >
        {t("page.schedules.scheduleDetails.cancel.button")}
      </Button>
    </>
  );
};

export default memo(NewCancelScheduleButton);
